import { Divider, Drawer, Stack, Typography } from '@mui/material';
import { IconX } from '@tabler/icons-react';
import React from 'react';
import UnstakeXVirtualForm from './UnstakeXVirtualForm';
interface ConvertVirtualDrawerProps {
  isOpen: boolean;
  onClose: () => void;
}
const UnstakeXVirtualDrawer: React.FC<ConvertVirtualDrawerProps> = ({
  isOpen,
  onClose,
}) => {
  const closeDrawer = () => {
    onClose();
  };

  return (
    <div>
      <Drawer anchor={'right'} open={isOpen} onClose={closeDrawer}>
        <Stack
          height="100%"
          sx={{
            width: {
              xs: '100vw',
              sm: '60vw',
              md: '50vw',
              lg: '30vw',
            },
          }}
        >
          <Stack
            m={3}
            direction={'row'}
            justifyContent={'space-between'}
            alignItems={'center'}
            gap={2}
          >
            <Stack
              flex={15}
              display={'flex'}
              justifyContent={'space-between'}
              flexDirection={'row'}
              alignItems={'center'}
            >
              <Typography variant="h6" fontWeight={'bold'}>
                Convert $xVIRTUAL to $VIRTUAL
              </Typography>
              <IconX onClick={() => closeDrawer()} cursor={'pointer'} />
            </Stack>
          </Stack>

          <Divider />
          <UnstakeXVirtualForm onClose={() => closeDrawer()} />
        </Stack>
      </Drawer>
    </div>
  );
};

export default UnstakeXVirtualDrawer;
